import React, { Component } from 'react';
import { Page } from 'components/page-container';
import { Filters } from 'modules/filters/containers/Filters';
import { FiltersInput } from 'modules/filters/components/FiltersInput';
import { IStore } from 'reducers/index';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { connect } from 'react-redux';
import { FiltersDateInput } from 'modules/filters/components/FiltersDateInput';
import { FiltersSelect } from 'modules/filters/components/FiltersSelect';
import { setSort } from 'actions/filters';
import { ISortModel } from 'reducers/filters/models';
import { setSortForTable } from 'utilities/tables';
import { INickname } from 'reducers/nickname';
import InPageDialog from '../../../components/page-dialog';
import { RouteComponentProps, withRouter } from 'react-router';

import {
    clearFilters,
    resetSort,
    setFilter,
    applyFiltersAction
} from 'actions/filters';
import { ISort } from 'views/job-costing/search/models';
import { bulkDownloadFile, fetchDownloadChargeLogs, resetEtsDownload } from 'actions/ets';
import { ExceptionManagement } from 'components/exception-management/ExceptionManagement';
import { colsDownloadCharge } from 'components/exception-management/constants';
import { bulkDownloadfile } from 'utilities/download';
import { fetchBlobFileDownload } from 'actions/historyLog';

interface IMapState {
    data: any;
    nickname: INickname;
    blob: any,
    error: any,
    bulkDownloadFile: any,
    bulkDownloadfilename: any,
}

interface IMapDispatch {
    fetchDownloadChargeLogs: (pageNumber: number, pageSize: number) => Promise<void>;
    setSort: (sort: ISortModel) => void;
    bulkDownloadFileSummary: (id: any) => void;
    clearFilters: () => void;
    resetSort: () => void;
    setFilter: (name: string, value: string | boolean | any | number) => void;
    applyFilters: () => void;
    getDownloadFile: (id: any) => Promise<void>;
    resetEtsDownload: () => void;

}

interface IEventLogsProps extends RouteComponentProps, IMapState, IMapDispatch { }

interface IEventLogsState {
    sorted: any[] | ISort[];
    isFieldDisabled: boolean;
    isFetchinProgress: boolean;
    page: number;
    pageSize: number;
    data: any[],
    file: any,
    timeofrequest: number,
    showDialog: boolean,
    message: string,
    isError: boolean,
    filterKey: string,
    filterValue: string,
    shouldSubmitOnLoad: boolean,
    startDate: boolean,
    docNumber: boolean,
}

export class _ChargeImportLogs extends Component<IEventLogsProps, IEventLogsState> {
    public state = {
        sorted: [],
        isFieldDisabled: false,
        isFetchinProgress: false,
        page: 0,
        pageSize: 10,
        timeofrequest: 0,
        file: '',
        showDialog: false,
        shouldSubmitOnLoad: false,
        data: [],
        message: '',
        isError: true,
        filterKey: '',
        filterValue: '',
        startDate: false,
        docNumber: false
    };
    
    public componentDidUpdate(props: any, state: any) {
        if (this.props.data !== props.data && this.props.data) {
            this.setState({ isFetchinProgress: false })
        }
        if (this.props.bulkDownloadFile !== props.bulkDownloadFile || this.props.bulkDownloadfilename !== props.bulkDownloadfilename) {
            if(props.bulkDownloadFile) {
                bulkDownloadfile(props.bulkDownloadFile, props.bulkDownloadfilename)
              }
        }
        if (this.props.error !== props.error && this.props.error) {
            this.setState({
                isFetchinProgress: false,
                showDialog: true,
                isError: true,
                message: this.props.error
            })
        }
    }
    public componentDidMount() {
        this.props.clearFilters()
        this.setState({
            shouldSubmitOnLoad: true,
            pageSize: 10
        }, () => {
            this.fetchEventsList({ page: 0, pageSize: this.state.pageSize })
        })
    }
    public componentWillUnmount() {
        this.props.clearFilters()
        this.props.resetSort()
        this.props.resetEtsDownload();
    }
    
    public render() {
        return (
            <React.Fragment>
                <Page>
                    <div className={'padding-top-xLarge'}>
                        <Filters
                            tableNameKey="FileDownloadFiltersFilters"
                            fetchFunction={() => {
                                this.targetFetch()
                            }}
                            resetErrors={() => {
                                this.applyEmptyFilters()
                                this.setState({ startDate: false, docNumber: false })
                            }}
                            disableSubmit={this.state.startDate || this.state.docNumber}
                            filters={[
                                <FiltersInput
                                    name="fileName"
                                    label="File Name"
                                    key="fileName"
                                    readonly={this.state.isFieldDisabled}
                                />,
                                <FiltersSelect
                                    key="Status"
                                    name="Status"
                                    label="Status"
                                    options={[
                                        { optionText: 'New', label: 'Awaiting AntiVirus Scan', value: 'New' },
                                        { optionText: 'Export In Progress', label: 'Virus Detected', value: 'ExportInProgress' },
                                        { optionText: 'Ready For Download', label: 'Scanned', value: 'ReadyForDownload' },
                                        { optionText: 'Failed', label: 'Scan Bypassed', value: 'Failed' },
                                    ]}
                                />,
                                <FiltersInput
                                    name="createdBy"
                                    label="Downloaded By"
                                    key="createdBy"
                                    readonly={this.state.isFieldDisabled}
                                />,
                                <FiltersDateInput
                                    name="startDate"
                                    label="Requested time from"
                                    key="startDate"
                                    relatedField="endDate"
                                    type="dateFromTo"
                                    setValidity={(val: any) => this.setState({ startDate: val })}
                                    isInvalid={this.state.startDate}
                                    withTime={false}
                                />,
                                <FiltersDateInput
                                    name="endDate"
                                    label="Requested time to"
                                    key="dateto"
                                    type="dateFromTo"
                                    minValue="startDate"
                                    setValidity={(val: any) => this.setState({ startDate: val })}
                                    isInvalid={this.state.startDate}
                                    withTime={false}
                                />
                            ]}
                        />
                        <InPageDialog
                            showDialog={this.state.showDialog}
                            type={this.state.isError ? 'error' : 'success'}
                            message={this.state.message}
                            closeMethod={() => this.setState({ showDialog: false, isError: true })} />
                        <ExceptionManagement
                            file={this.props.blob}
                            cols={colsDownloadCharge}
                            calculateAging={false}
                            fetchData={this.fetchEventsList}
                            data={this.props.data.data}
                            sendReprocess={this.fetchEventsList}
                            toggleReprocess={this.fetchEventsList}
                            tableName={'exception-management-file-download'}
                            pageCount={Math.ceil(this.props.data.totalCount / this.state.pageSize)}
                            linkAction={(id: any) => this.props.bulkDownloadFileSummary(id)}
                            handleDownload={this.handleDownloadFromTable}
                        />
                    </div>
                </Page>
            </React.Fragment>
        );
    }

    private handleDownloadFromTable = async(requestId : string) => {
        if(requestId) {
            await this.props.getDownloadFile(requestId)
            if(this.props.bulkDownloadFile) {
                bulkDownloadfile(this.props.bulkDownloadFile, this.props.bulkDownloadfilename)
              }
          }
    }

    private applyEmptyFilters = () => {
        this.props.applyFilters();
    }
    private targetFetch = (page:number = this.state.page, pageSize:number = this.state.pageSize) => {
        this.props.setFilter('Category', 'ExportCharges');
        const tempPageSize: any = localStorage.getItem('pageSize-exception-management-file-download') ?
        localStorage.getItem('pageSize-exception-management-file-download') : pageSize
        this.setState({
            isFetchinProgress: true,
            pageSize: tempPageSize
        })
        this.props.fetchDownloadChargeLogs(page, tempPageSize)
    }
    private fetchEventsList = (tableData: any) => {
        const samePageRequest = (tableData.page + 1 !== this.state.page || tableData.pageSize !== this.state.pageSize) || (new Date().getTime() - this.state.timeofrequest) > 500
        if (samePageRequest && this.state.shouldSubmitOnLoad && !this.state.isFetchinProgress) {
            this.setState({
                showDialog: false,
                page: tableData.page + 1,
                pageSize: tableData.pageSize,
                timeofrequest: new Date().getTime(),
                isFetchinProgress: true
            }, () => {
                if (tableData && tableData.sorted && tableData.sorted.length > 0 && tableData.sorted[0].id && tableData.sorted[0]!.id === 'errorLogURl') {
                    this.setState({ isFetchinProgress: false });
                    return
                }
                if (tableData && tableData.sorted) {
                    this.setState({ sorted: tableData.sorted });
                    setSortForTable(tableData.sorted, this.props.setSort);
                } else if (this.state.sorted && this.state.sorted.length) {
                    setSortForTable(this.state.sorted, this.props.setSort);
                }
                this.targetFetch(this.state.page, this.state.pageSize);
            });
        }
    };
}

const mapStateToProps = (state: IStore): IMapState => ({
    data: state.ets.bulkDownloadLogs,
    nickname: state.nickname.userNickName,
    blob: state.historyLog.blob,
    error: state.exceptions.errors,
    bulkDownloadFile: state.ets.bulkDownloadFile,
    bulkDownloadfilename: state.ets.bulkDownloadfilename,
});

const mapDispatch = (dispatch: ThunkDispatch<any, any, Action>): IMapDispatch => ({
    fetchDownloadChargeLogs: (pageNumber: number, pageSize: number) => dispatch(fetchDownloadChargeLogs(pageNumber, pageSize)),
    setSort: (sort: ISortModel) => dispatch(setSort(sort)),
    bulkDownloadFileSummary: (id: any) => dispatch(fetchBlobFileDownload(id)),
    clearFilters: () => dispatch(clearFilters()),
    resetSort: () => dispatch(resetSort()),
    setFilter: (name: string, value: string | boolean | any | number) => dispatch(setFilter(name, value)),
    applyFilters: () => dispatch(applyFiltersAction()),
    getDownloadFile: (id: string) => dispatch(bulkDownloadFile(id)),
    resetEtsDownload: () => dispatch(resetEtsDownload())
});

export const __ChargeImportLogs = connect<IMapState, IMapDispatch, {}, IStore>(mapStateToProps, mapDispatch)(_ChargeImportLogs);
export const Export = withRouter(__ChargeImportLogs)